import { useEffect, useState } from "react";
import FrPersonalInfo from "../../components/FRPersonalInfo/frPersonalInfo";
import FamilyProfileTabs from "../../components/FamilyProfileTabs/FamilyProfileTabs";
import useAuthGuard from "../../Hooks/useAuthGuard";
import useAuthUserData from "../../Hooks/useAuthUserData";
import { registerScan, updateScanRegister } from "../../Services/scansService";
import { sendScanNotification } from "../../Services/notificationService";
import { useGetID, useQuery } from "./../../Hooks/useSuscribersService";
import { useLocation } from "react-router-dom";
import { FR_ROLE } from "../../utils/constants";
import { getFamily, getUser } from "../../Services/userService";
import { Subscriber } from "../../Interfaces/subscriber";

const Details = () => {
  useAuthGuard({
    allowedRoles: [
      FR_ROLE.FIRST_RESPONDER_USER,
      FR_ROLE.FIRST_RESPONDER_ADMIN,
      FR_ROLE.FIRST_RESPONDER_OWNER,
    ],
  });
  const { user } = useAuthUserData();
  const navState = useLocation();
  const [isScanRegistered, setIsScanRegistered] = useState(false);
  let query = useQuery();
  const currentAccessCode = query.get("mmh_id")!.toLowerCase().replaceAll("mmh", "");
  const originalScannedAccessCode = navState.state?.scannedAccessCode || currentAccessCode;
  const { idSuscriber, loadUser } = useGetID(currentAccessCode);

  const [familyMembers, setFamilyMembers] = useState<Subscriber[]>([]);
  const [activeUserId, setActiveUserId] = useState<string>("");
  const [originalScannedUserId, setOriginalScannedUserId] = useState<string>("");

  console.log({ scanMethod: navState.state?.scanMethod });

  useEffect(() => {
    if (idSuscriber) {
      if (!activeUserId) {
        setActiveUserId(idSuscriber);
      }
      getUser(idSuscriber).then((subscriber) => {
        getFamily(subscriber.idParentMember ?? subscriber.id).then((res) => {
          const registered = res.filter(
            (m) => m.orderProduct && m.orderProduct.length > 0
          );
          // Resolve the originally scanned member's ID from their access code
          const originalMember = registered.find(
            (m) => m.accessCode?.toLowerCase().replace("mmh", "") === originalScannedAccessCode
          );
          if (originalMember) {
            setOriginalScannedUserId(originalMember.id);
          }

          // Keep original scanned member first, rest in natural order
          const originalId = originalMember?.id;
          const ordered = [
            ...registered.filter((m) => m.id === originalId),
            ...registered.filter((m) => m.id !== originalId),
          ];
          setFamilyMembers(ordered);
        });
      });
    }
  }, [idSuscriber]);

  const handleSelectMember = (id: string) => {
    setActiveUserId(id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const putScan = async () => {
      if (idSuscriber && user && !isScanRegistered) {
        if (navState?.state?.registerId) {
          await updateScanRegister(
            user?.id,
            navState?.state?.registerId,
            "Full Profile",
            navState?.state?.scanMethod ?? "MMHID"
          );
        } else {
          await registerScan(user?.id, {
            idSubscriber: idSuscriber,
            type: "Full Profile",
            method: navState?.state?.scanMethod ?? "MMHID",
          });
        }
        setIsScanRegistered(true);

        // Send email notification after successful scan registration
        try {
          await sendScanNotification({
            subscriberId: idSuscriber,
            scanMethod: navState?.state?.scanMethod ?? "MMHID",
          });
        } catch (notificationError) {
          console.error("Failed to send scan notification:", notificationError);
        }
      }
    };
    putScan();
  }, [idSuscriber, user]);

  if (loadUser) return <div>Loading...</div>;

  return (
    <div>
      {idSuscriber ? (
        <FrPersonalInfo
          key={activeUserId}
          idUser={activeUserId}
          scannedAccessCode={originalScannedAccessCode}
          headerContent={
            <FamilyProfileTabs
              familyMembers={familyMembers}
              activeUserId={activeUserId}
              scannedUserId={originalScannedUserId || idSuscriber}
              onSelectMember={handleSelectMember}
            />
          }
        />
      ) : (
        <div>No subscriber info</div>
      )}
    </div>
  );
};

export default Details;
